var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgToolsHammer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6728 6.69779L16.0557 4.0807C15.3615 3.3864 14.4199 2.99634 13.4381 2.99634C12.4563 2.99634 11.5147 3.3864 10.8205 4.0807L9.64706 5.25419C9.5146 5.38639 9.47494 5.58541 9.54658 5.75828C9.61823 5.93116 9.78706 6.04377 9.97419 6.04352H10.7085C11.1993 6.04371 11.67 6.23873 12.017 6.58574L12.7834 7.35206V8.66161L14.7472 10.6244L15.7576 10.3243L16.71 11.2757V12.5842L17.2722 13.1465C17.6848 13.5588 18.3533 13.5588 18.7659 13.1465L21.1979 10.7135C21.3964 10.5156 21.5079 10.2469 21.5079 9.96665C21.5079 9.6864 21.3964 9.41768 21.1979 9.21984L20.6366 8.65861H19.3271L18.3757 7.70621L18.6728 6.69779Z",
    stroke: "#989898",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.18838 20.3085V20.3085C3.65813 20.778 4.30304 21.0294 4.96665 21.0017C5.63026 20.9739 6.25193 20.6696 6.68083 20.1624L14.7472 10.6244L12.7834 8.66162L3.31543 16.831C2.81573 17.2624 2.51812 17.8823 2.49402 18.5421C2.46991 19.2018 2.72149 19.8418 3.18838 20.3085Z",
    stroke: "#989898",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolsHammer);
export default __webpack_public_path__ + "static/media/tools-hammer.83e97c4c8af4223ec252d3ec99e63917.svg";
export { ForwardRef as ReactComponent };